import axios from "axios";
import createMultiParamFromArray from "@/utils/multi-param-from-array";
import createMultiParamFromObject from "@/utils/multi-param-from-object";
import endpoints from "@/api/endpoints";

export function getCustomers() {
  return axios.get(endpoints.customers.list).then(response => {
    if (response.data) {
      return response.data;
    } else throw new Error();
  });
}

export function getCompanyParamsLists(params) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/lists?${createMultiParamFromArray("code_list", params)}`)
      .then(response => {
        if (response.data) {
          return resolve(response.data);
        } else return reject(new Error("Bad response"));
      })
      .catch(err => reject(new Error(err)));
  });
}

export function searchArticles(data) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/searchArticles", data)
      .then(response => {
        if (response.data.success) {
          return resolve(response.data.articles);
        } else return reject(new Error("Bad response"));
      })
      .catch(err => reject(new Error(err)));
  });
}

export function searchArticlesByStock(filters) {
  const sQuery = createMultiParamFromObject(
    Object.keys(filters)
      .filter(f => (Array.isArray(filters[f]) ? filters[f].length : filters[f]))
      .reduce((acc, f) => ({ ...acc, [f]: filters[f] }), {})
  );

  return new Promise((resolve, reject) => {
    axios
      .get(`/api/storeReportArticules?${sQuery}`)
      .then(response => {
        if (response.data.success) {
          return resolve(response.data);
        } else return reject(new Error("Bad response"));
      })
      .catch(err => reject(new Error(err)));
  });
}

export function filtersByStock(filters) {
  const sQuery = createMultiParamFromObject(
    Object.keys(filters)
      .filter(f => (Array.isArray(filters[f]) ? filters[f].length : filters[f]))
      .reduce((acc, f) => ({ ...acc, [f]: filters[f] }), {})
  );

  return new Promise((resolve, reject) => {
    axios
      .get(`/api/storeReportFilters?${sQuery}`)
      .then(response => {
        if (response.data.success) {
          return resolve(response.data.filters);
        } else return reject(new Error("Bad response"));
      })
      .catch(err => reject(new Error(err)));
  });
}

export function getMarketArea() {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/stocksMarketAreas")
      .then(response => {
        if (response.data.success) {
          return resolve(response.data);
        } else return reject(new Error("Bad response"));
      })
      .catch(err => reject(new Error(err)));
  });
}
